import { UrlSegment } from '@angular/router'

export function uuidMatcher(segments: UrlSegment[]): { consumed: UrlSegment[]; posParams?: Record<string, UrlSegment> } | null {
  if (segments.length === 0) return null

  const firstSegment = segments[0]
  const isValidUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(firstSegment.path)

  if (!isValidUuid) return null

  return {
    consumed: [firstSegment],
    posParams: { organizationId: firstSegment },
  }
}
